import { render } from "./ProvidersView.vue?vue&type=template&id=3f2515d8"
import script from "./ProvidersView.vue?vue&type=script&lang=js"
export * from "./ProvidersView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\deploy\\fire-conference\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__